var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "hamburger",
      attrs: { type: "button" },
      on: { click: _vm.toggleActiveState }
    },
    [
      _vm._m(0),
      _c("span", { staticClass: "u-sr-only" }, [
        _vm._v(_vm._s(_vm.buttonLabel))
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }